import { useMemo } from 'react';

import getParticipantsFromEventName from '@swf/sports/utils/getParticipantsFromEventName';

/**
 * Use this hook over `getParticipantsFromEventName` directly as it avoids
 * unnecessary regexp invocation on every render.
 */
const useParticipants = (eventName?: string) => {
  const participants = useMemo(() => getParticipantsFromEventName(eventName), [eventName]);

  return participants;
};

export default useParticipants;
